<template>
  <v-container v-if="!isPhoneBool" fluid class="pa-0" style="height: inherit !important;">

    <DraggableDividedLayout v-model="jobListWidth" :minValue="10" :maxValue="45" :hideCol1="!ShowJobs" height="48px">
      <template v-slot:col1>
        <JobsToolbar></JobsToolbar>
      </template>
      <template v-slot:col2>
        <PlanningToolbar @newEvent="e => { appointment = e; dialogtrigger++; }" :showMaps.sync="ShowMap" :jobListWidth="jobListWidth" />
      </template>
    </DraggableDividedLayout>

    <DraggableDividedLayout v-model="jobListWidth" :minValue="10" :maxValue="45" :hideCol1="!ShowJobs" :height="''+ (contentHeight - 48) + 'px'">
      <template v-slot:col1>
        <job-card-list :vertical="true" @select="jobSelect">
        </job-card-list>
      </template>
      <template v-slot:col2>

      <DraggableDividedLayout v-model="schedulerWidth" :minValue="10" :maxValue="80" :hideCol2="!ShowMap" >
        <template v-slot:col1>
          <div style="position: relative; height: 100%; width: 100%;">
              <Scheduler :routeData.sync="routeData" v-show="!listMode" ref="scheduler" @eventDialog="e => getExistingAppointmentForSchedulerElements(e)" @change="schedulerChange" />
             <EventList v-if="listMode" @eventDialog="e => getExistingAppointmentForSchedulerElements(e)" />
             <PlanningColorHelper :list="StatusList" />
          </div>
        </template>
        <template v-slot:col2>
          <PlanningMaps :center="selectedLocation || mainLocation" :mainLocationCoordinates="mainLocation" :routeData="routeData" ref="planningMaps"/>
        </template>
      </DraggableDividedLayout>
      </template>
    </DraggableDividedLayout>


    <AppointmentDialog :externaltrigger="dialogtrigger" :appointmentitem="appointment" :JobDetails="job"
      @Update="(app) => handleEventChange(app.Id)">
    </AppointmentDialog>
    <!--
    <EventDialog :externaltrigger="dialogtrigger" :appointmentitem="appointment" @Update="update">
    </EventDialog>
    -->
  </v-container>

  <empty-page v-else :icon="'mdi-calendar'"
    :title="$t('servicesystem.common_objects.fallbackterms.Unavailable_Feature_on_device')"
    :message="$t('servicesystem.common_objects.fallbackterms.Unavailable_Feature_Body')">
  </empty-page>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EmptyPage from "@/components/Sections/EmptyPage.vue";
import DraggableDividedLayout from "@/views/planning/DraggableDividedLayout.vue";
import EventList from "@/views/planning/EventList.vue";
import JobCardList from "@/views/planning/JobCardList.vue";
import Scheduler from "@/views/planning/Planner.vue";
import PlanningColorHelper from "@/views/planning/PlanningColorHelper.vue";
import PlanningToolbar from "@/views/planning/PlanningToolbar.vue";
//import EventDialog from "@/components/Dialogs/EventDialog.vue";
import AppointmentDialog from "@/components/Dialogs/AppointmentDialog.vue";
import JobsToolbar from "./JobsToolbar.vue";
import PlanningMaps from "./PlanningMaps.vue";

export default {
  name: "PlanningContainer",
  props: [],
  components: {
    PlanningToolbar,
    JobCardList,
    EmptyPage,
    DraggableDividedLayout,
    Scheduler,
    EventList,
    PlanningColorHelper,
    AppointmentDialog,
    PlanningMaps,
    JobsToolbar,
  },
  mixins: [clientAPI],

  data() {
    return {
      routeData: {},
      dialogtrigger: 1,
      appointment: null,
      job: null,
      schedulerWidth: 50,
      draggingDivider: false,
      selectedLocation: null,
    };
  },

  mounted() {
    this.$store.dispatch("plannerstore/GetDepartments");
  },

  methods: {
    schedulerChange() {
      this.$refs.planningMaps.schedulerChange()
    },
    jobSelect(item) {
      clientAPI.methods.getJobLocations(item.Id).then(response => {
        this.selectedLocation = { lng: response[0].Location.Longitude, lat: response[0].Location.Latitude }
      })
    },
    handleEventChange(id) {
      this.$refs.scheduler.addOrUpdateEventInStoreById(id)
      this.$refs.planningMaps.schedulerChange()
    },

    async getExistingAppointmentForSchedulerElements(schedulerElements) {
      var event = schedulerElements.eventRecord;
      var resource = schedulerElements.resourceRecord;
      var appId = event.id;
      var jobId = event.jobId;
      var existsInBE = !(await this.$store.dispatch("plannerstore/checkIdIsFrontendOnly", appId));

      if (existsInBE) {
        this.appointment = await clientAPI.methods.getAppointment(appId);
      }
      else {
        //parse to appointment
        var app = {
          Id: null,
          JobId: event.jobId,
          AppointmentDate: event.startDate,
          StartTime: event.startDate,
          EndTime: event.endDate,
          Type: event.type ?? 1,
          Subject: event.name,
          Participants: null,
          IsAbsence: !event.jobId,
        };
        if (resource) {
          app.Participants = [{ User: { Id: resource.id, Name: resource.name } }];
        }
        event.remove();
        this.appointment = app;
        jobId = app.JobId;
      }
      if (jobId) {
        this.job = await this.getJobById(jobId);
      }
      else {
        this.job = null;
      }
      this.dialogtrigger++;
    },
  },

  computed: {
    ShowJobs() {
      return !this.listMode && this.$store.getters["plannerstore/ShowJobs"];
    },

    ShowMap: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerMapShow");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerMapShow", value: update });
      },
    },

    mainLocation() {
      const loc = this.$store.state.GlobalSettings.Maps?.MainLocationCoordinates;
      if (loc) {
        const s = loc.split(",");
         return { lng: parseFloat(s[0].trim()), lat: parseFloat(s[1].trim()) };
      }
      else {
        return undefined;
      }
    },

    DisplayMode() {
      return this.$store.getters["prefrences/Prefrence"]("PlannerMode");
    },
    listMode() {
      var mode = this.$store.getters["prefrences/Prefrence"]("PlannerMode");
      return mode == 'List';
    },

    jobListWidth: {
      get() {
        return parseFloat(this.$store.getters["prefrences/Prefrence"]("PlannerJobListWidth"));
      },
      set(update) {
        //console.log(update)
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListWidth", value: update });
      },
    },

    StatusList() {
      return this.$store.getters["BackgroundUpdater/Value"]("StatusMap");
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
.divider {
  height: 100%;
  width: 4px;
  background: #e5e5e8;
  transform: translateX(-2px);
  position: absolute;
  top: 0;
  z-index: 5;
  cursor: ew-resize;
}

.divider:hover,
.divider.active {
  background: var(--v-tertiary-base);
}
</style>
